import React from 'react'
import BasicButton from './buttons/BasicButton'
import { Link } from 'react-router-dom'
import ROUTES from '../../application/utils/Routes'
import PageTitle from './PageTitle'

function AgentsTopbar() {
    return (
        <div className="flex justify-between">
            
            <PageTitle title="Agents"/>

            <div>
                <Link to={ROUTES.ADDAGENTS}>
                    <BasicButton text="New Agent" />
                </Link>
            </div>

        </div>
    )
}

export default AgentsTopbar